'use strict';

import category from './category';
import details from './details';
import ellipsis from './ellipsis';
import percentageBars from './percentage-bars';
import wikiLink from './wiki-link';

export default {
  category,
  details,
  ellipsis,
  percentageBars,
  wikiLink
};